export const NegotiationDialogStyles = {
  width: '600px',
};

export const DEFAULT_BUYING_OFFERS_PER_PAGE = 10;
export const DEFAULT_BUYING_OFFERS_NUMBER_BUTTONS = 5;
export const DEFAULT_BUYING_OFFERS_TO_SHOW_CTA_TOP = 3;
export const DEFAULT_BUYING_OFFERS_SKELETON_CARDS = [{ id: 'skeleton-1' }, { id: 'skeleton-2' }, { id: 'skeleton-3' }];
